import { useCollectingFormContext } from '../context/collectingContext'
import { useUser } from './useUser'

// Business associations lead: data (transactions, spending limit) is scoped to
// the selected association, falling back to the logged-in user's own number
// when none is selected (the "own use" case, where association.id === customerNumber).
export const useActiveCustomerNumber = (): number | undefined => {
  const { selectedBusinessAssociation } = useCollectingFormContext()
  const { customerNumber } = useUser()

  return selectedBusinessAssociation?.id ?? customerNumber
}
